import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { getUserPanelRole } from 'selectors';
import { isNotificationVisible } from 'helpers';

const SeeAllNotifcation = () => {
  const panel_role = useSelector(getUserPanelRole);

  return (
    isNotificationVisible(panel_role) && (
      <div className="d-flex align-items-center w-100 justify-content-center pt-2 pb-1">
        <NavLink className="btn btn-link btn-sm" to="/panel/notifications">
          <span>See all +</span>
        </NavLink>
      </div>
    )
  );
};

export default SeeAllNotifcation;
